module.exports = __webpack_public_path__ + "static/media/leaf_right_cutted.91612e45.png";